import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { RequireLogin } from './RequireLogin';
import { NotFound } from '@app/core';
import { ParticipationReturnLanding } from './ParticipationReturnLanding';

export const StudyReturnLandings = () => {
  return (
    <AnalyticsCategoryProvider category={Categories.LOGIN}>
      <Routes>
        <Route path="require-login/:verb/:code" element={<RequireLogin />} />
        <Route path="not-found" element={<NotFound />} />
        <Route path="p/:id/:message" element={<ParticipationReturnLanding />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AnalyticsCategoryProvider>
  );
};
